import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import * as Yup from "yup";

const AddDialog = ({
  setSigners,
  setNewSigners,
  setAddDialogOpen,
  isAddDialogOpen,
  newSigners,
  signers,
}) => {
  const [afmError, setAfmError] = useState("");
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [newSigner, setNewSigner] = useState({
    afm: "",
    first_name: "",
    last_name: "",
  });

  const handleAddConfirm = () => {
    const schema = Yup.object().shape({
      afm: Yup.string()
        .required("Το ΑΦΜ είναι υποχρεωτικό")
        .length(9, "Το ΑΦΜ πρέπει να είναι 9 χαρακτήρες")
        .test(
          "is-unique",
          "Το ΑΦΜ υπάρχει ήδη στον Πίνακα σας.",
          (value) => !isAfmDuplicate(value),
        ),
      first_name: Yup.string()
        .required("Το όνομα είναι υποχρεωτικό")
        .max(50, "Το όνομα πρέπει να είναι έως 50 χαρακτήρες"),
      last_name: Yup.string()
        .required("Το επώνυμο είναι υποχρεωτικό")
        .max(50, "Το επώνυμο πρέπει να είναι έως 50 χαρακτήρες"),
    });

    schema
      .validate(newSigner, { abortEarly: false })
      .then(() => {
        setAfmError("");
        setFirstNameError("");
        setLastNameError("");

        const updatedNewSigner = { ...newSigner, isNew: true };
        setNewSigners((prevNewSigners) => [
          ...prevNewSigners,
          updatedNewSigner,
        ]);
        setSigners((prevSigners) => [...prevSigners, updatedNewSigner]);
        setAddDialogOpen(false);
        setSelectedAfm(updatedNewSigner.afm);
        setNewSigner({
          afm: "",
          first_name: "",
          last_name: "",
        });
      })
      .catch((errors) => {
        errors.inner?.forEach((error) => {
          const trimmedFieldName = error.path.trim();

          if (error.path === "afm") {
            setAfmError(error.message);
          } else if (error.path === "first_name") {
            setFirstNameError(error.message);
          } else if (error.path === "last_name") {
            setLastNameError(error.message);
          }
        });
      });
  };

  const handleAddCancel = () => {
    const updatedNewSigner = { ...newSigner, isNew: true };
    setAddDialogOpen(false);
    setNewSigner({
      afm: "",
      first_name: "",
      last_name: "",
    });
  };

  const isAfmDuplicate = (afm) => {
    return (
      signers.some((signer) => signer.afm === afm) ||
      newSigners.some((signer) => signer.afm === afm)
    );
  };

  return (
    <Dialog
      open={isAddDialogOpen}
      onClose={handleAddCancel}
      aria-labelledby="add-dialog-title"
    >
      <DialogTitle id="add-dialog-title">Προσθήκη Υπογράφοντα</DialogTitle>
      <DialogContent>
        <TextField
          label="ΑΦΜ"
          value={newSigner.afm}
          onChange={(e) => setNewSigner({ ...newSigner, afm: e.target.value })}
          fullWidth
          margin="normal"
          error={Boolean(afmError)}
          helperText={afmError}
        />
        <TextField
          label="Όνομα"
          value={newSigner.first_name}
          onChange={(e) =>
            setNewSigner({ ...newSigner, first_name: e.target.value })
          }
          fullWidth
          margin="normal"
          error={Boolean(firstNameError)}
          helperText={firstNameError}
        />
        <TextField
          label="Επώνυμο"
          value={newSigner.last_name}
          onChange={(e) =>
            setNewSigner({ ...newSigner, last_name: e.target.value })
          }
          fullWidth
          margin="normal"
          error={Boolean(lastNameError)}
          helperText={lastNameError}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleAddCancel}>Ακύρωση</Button>
        <Button onClick={handleAddConfirm} color="primary" variant="contained">
          Προσθήκη
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddDialog;
